import { LocalStorage } from "@made-people/local-storage";

export const ALGOLIA_USER_TOKEN_KEY = "algolia-user-token";

// Generate or retrieve Algolia user token for insights tracking
export const getOrCreateAlgoliaUserToken = (): string => {
  const existingToken = LocalStorage.getWithExpiry(ALGOLIA_USER_TOKEN_KEY);
  if (existingToken) {
    return existingToken;
  }

  // Generate a new token and store it for 1 year
  const newToken = `user-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  LocalStorage.setWithExpiry(
    ALGOLIA_USER_TOKEN_KEY,
    newToken,
    365 * 24 * 60 * 60,
  ); // 1 year
  return newToken;
};
